import './Portraits.css'

function Portraits() {
    return (
        <div className="portraitsPageContainer">Portraits Page</div>
    );
}

export default Portraits;
